import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentMethod, type PaymentResult } from '@/api/types/payments.types';
import { formatDate, formatNumber } from '@/utils/helpers';
import { getPaymentMethodLabel } from '@/components/Payment/PaymentMethods.helpers';

export type BulkPromotionPaymentReceipt = {
  amount: string;
  paymentDate: string;
  paymentMethod: string;
  serviceName: string;
};

type Props = {
  onPaymentSuccess: () => void;
};

export function useMyAdsBulkPromotionReceipt({ onPaymentSuccess }: Props) {
  const { t } = useTranslation();
  const [completedPayment, setCompletedPayment] =
    useState<PaymentResult | null>(null);
  const completedPaymentAmount = formatNumber(completedPayment?.amount, 2);
  const paymentReceipt: BulkPromotionPaymentReceipt | null = completedPayment
    ? {
        amount: completedPaymentAmount ? `${completedPaymentAmount} AZN` : '',
        paymentDate: completedPayment.paymentDate
          ? formatDate(completedPayment.paymentDate, 'dd.MM.yyyy')
          : '',
        paymentMethod: getPaymentMethodLabel(
          t,
          completedPayment.paymentMethod ?? PaymentMethod.Wallet
        ),
        serviceName: completedPayment.serviceName ?? '',
      }
    : null;

  function completePayment(payment: PaymentResult) {
    onPaymentSuccess();
    setCompletedPayment(payment);
  }

  function closePaymentReceipt() {
    setCompletedPayment(null);
  }

  return {
    closePaymentReceipt,
    completePayment,
    paymentReceipt,
  };
}
